import {CookieStorage} from 'amazon-cognito-identity-js';
import parser from 'tld-extract';
import {cognitoConfig} from './cognitoConfig';

// https://stackoverflow.com/questions/59409205/aws-cognito-cookie-storage
const amplifyInit = () => {
  const tld =
    window.location.hostname === 'localhost'
      ? null
      : parser(window.location.href, {allowUnknownTLD: true});
  let domain = tld ? tld.domain : 'localhost';
  if (domain === 'saltusspace.co.uk') {
    domain = window.location.hostname;
  }

  /**
   * @type {import('aws-amplify').ResourcesConfig}
   */
  const config = {
    Auth: {
      Cognito: {
        allowGuestAccess: true,
        passwordFormat: {
          minLength:
            cognitoConfig.aws_cognito_password_protection_settings
              .passwordPolicyMinLength,
          requireLowercase:
            cognitoConfig.aws_cognito_password_protection_settings.passwordPolicyCharacters.includes(
              'REQUIRES_LOWERCASE'
            ),
          requireUppercase:
            cognitoConfig.aws_cognito_password_protection_settings.passwordPolicyCharacters.includes(
              'REQUIRES_UPPERCASE'
            ),
          requireNumbers:
            cognitoConfig.aws_cognito_password_protection_settings.passwordPolicyCharacters.includes(
              'REQUIRES_NUMBERS'
            ),
        },
        userPoolId: cognitoConfig.aws_user_pools_id,
        userPoolClientId: cognitoConfig.aws_user_pools_web_client_id,
        loginWith: {
          email: true,
          oauth: {
            domain: `${process.env.VITE_APP_AUTH_DOMAIN}`,
            scopes: [
              'phone',
              'email',
              'profile',
              'openid',
              'aws.cognito.signin.user.admin',
            ],
            redirectSignIn: [`${window.location.origin}/`],
            redirectSignOut: [`${window.location.origin}/`],
            responseType: 'code',
            providers: [
              {
                custom: process.env.VITE_APP_IDP,
              },
            ],
          },
        },
      },
    },
  };

  const cookieStorage = new CookieStorage({
    domain,
    path: '/',
    expires: 365,
    secure: process.env.VITE_APP_SECURE_COOKIE === 'true',
  });

  return {
    config,
    cookieStorage,
  };
};

export default amplifyInit;
